import React from 'react';
import {
	ITagItemProps,
	ITagItemStyles,
	TagItemCompat as TagItem,
} from 'components/FluentUICompat';

/**
 * This must not be memoized because the app throws an error if we try using
 * hooks.
 */
const styles: Partial<ITagItemStyles> = {root: {maxWidth: '100%'}};

export const BaselineTag = (
	tagItemProps: ITagItemProps,
): React.ReactElement => {
	return (
		<TagItem {...tagItemProps} styles={styles}>
			{tagItemProps.item.name}
		</TagItem>
	);
};
